








import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({})
export default class MultiText extends Vue {
    @Prop() value?: string;
}
